module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    ref: "dialog",
    staticStyle: {
      "min-width": "1280px"
    },
    attrs: {
      "title": "配置控件",
      "size": "large"
    }
  }, [_c('div', {
    staticClass: "m-b-10"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": function($event) {
        _vm.setTempInputType(30)
      }
    }
  }, [_vm._v("全部不使用")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": function($event) {
        _vm.setTempInputType(40)
      }
    }
  }, [_vm._v("全部不可见")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": function($event) {
        _vm.setTempInputType(10)
      }
    }
  }, [_vm._v("全部只读")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": function($event) {
        _vm.setTempInputType(20)
      }
    }
  }, [_vm._v("全部可写")]), _vm._v(" "), _c('el-select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.oldRule),
      expression: "oldRule"
    }],
    staticClass: "w-150 m-l-10 m-r-10",
    domProps: {
      "value": (_vm.oldRule)
    },
    on: {
      "input": function($event) {
        _vm.oldRule = $event
      }
    }
  }, _vm._l((_vm.rules), function(item) {
    return _c('el-option', {
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  })), _vm._v(" "), _c('span', [_vm._v("替换")]), _vm._v(" "), _c('el-select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.curRule),
      expression: "curRule"
    }],
    staticClass: "w-150 m-l-20",
    domProps: {
      "value": (_vm.curRule)
    },
    on: {
      "input": function($event) {
        _vm.curRule = $event
      }
    }
  }, _vm._l((_vm.rules), function(item) {
    return _c('el-option', {
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  })), _vm._v(" "), _c('el-button', {
    staticClass: "m-l-10",
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": _vm.replaceRule
    }
  }, [_vm._v("确认")])]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "f-l p-r-10 m-r-10 bor-r-ccc",
    staticStyle: {
      "width": "60%"
    }
  }, [_c('el-table', {
    ref: "inputList",
    attrs: {
      "data": _vm.tempInputList,
      "row-class-name": _vm.setCurrentInputStyle,
      "height": "400"
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "default.title",
      "label": "名称"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "控件类型"
    },
    scopedSlots: {
      default: function(scope) {
        return [_c('span', [_vm._v(_vm._s(_vm._f("inputTypeData")(scope.row.default.type)))])]
      }
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "权限",
      "width": "325"
    },
    scopedSlots: {
      default: function(scope) {
        return [_c('el-radio-group', {
          directives: [{
            name: "model",
            rawName: "v-model",
            value: (scope.row.auth),
            expression: "scope.row.auth"
          }],
          domProps: {
            "value": (scope.row.auth)
          },
          on: {
            "change": function($event) {
              _vm.authChange(scope.row)
            },
            "input": function($event) {
              scope.row.auth = $event
            }
          }
        }, [_c('el-radio', {
          attrs: {
            "label": _vm.INPUT_HIDDEN,
            "disabled": scope.row.disabled
          }
        }, [_vm._v("不使用")]), _vm._v(" "), _c('el-radio', {
          attrs: {
            "label": _vm.INPUT_EXIST,
            "disabled": _vm.isDisabled(scope.row)
          }
        }, [_vm._v("不可见")]), _vm._v(" "), _c('el-radio', {
          attrs: {
            "label": _vm.INPUT_READONLY,
            "disabled": scope.row.disabled
          }
        }, [_vm._v("只读")]), _vm._v(" "), _c('el-radio', {
          attrs: {
            "label": _vm.INPUT_EDITABLE,
            "disabled": _vm.isDisabled(scope.row)
          }
        }, [_vm._v("可写")])])]
      }
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "width": "80"
    },
    scopedSlots: {
      default: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "text",
            "disabled": scope.row.auth === _vm.INPUT_HIDDEN
          },
          on: {
            "click": function($event) {
              _vm.configRightInput(scope.row)
            }
          }
        }, [_vm._v("配置")])]
      }
    }
  }), _vm._v(" ")])]), _vm._v(" "), _vm._v(" "), _c('right-input-config', {
    staticStyle: {
      "width": "36%"
    },
    attrs: {
      "inputList": _vm.tempInputList,
      "userInfos": _vm.userInfos,
      "structList": _vm.structList,
      "currentInput": _vm.currentInput
    }
  }), _vm._v(" ")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": _vm.closeDialog
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.confirmNewInputList
    }
  }, [_vm._v("确 定")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-698205f2!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Common/business/inputConfig/inputList.vue
// module id = 1902
// module chunks = 2